/**
 * Canonical route paths.
 *
 * Every `Link`, `Navigate`, and route definition reads from here, so a path
 * change is a single edit and a typo is a compile error rather than a dead
 * link discovered in production.
 */
export const ROUTE_PATHS = {
  root: '/',
  login: '/login',
  dashboard: '/dashboard',
  accounts: '/accounts',
  billing: '/billing',
  settings: '/settings',
  forbidden: '/forbidden',
  notFound: '*',
} as const;

export type RoutePath = (typeof ROUTE_PATHS)[keyof typeof ROUTE_PATHS];
